import React from 'react';
import { TbTargetArrow } from "react-icons/tb";
import { PiChartLineUpLight, PiWarningCircleLight, PiCurrencyDollarLight } from "react-icons/pi";

interface BudgetsSummaryProps {
  summary: {
    total_budget?: number;
    total_actual_sales?: number;
    cumplimiento_pct?: number;
    proyeccion_pesos?: number;
    proyeccion_pct?: number;
    faltante_pesos?: number;
    faltante_pct?: number;
  };
}

export default function BudgetsSummary({ summary = {} }: BudgetsSummaryProps) {
  const {
    total_budget = 0,
    total_actual_sales = 0,
    cumplimiento_pct = 0,
    proyeccion_pesos = 0,
    proyeccion_pct = 0,
    faltante_pesos = 0,
    faltante_pct = 0,
  } = summary;

  const cumplimientoColor = cumplimiento_pct >= 100 ? '#2e7d32' : cumplimiento_pct >= 70 ? '#ed6c02' : '#d32f2f';
  const proyeccionColor = proyeccion_pct >= 100 ? '#2e7d32' : proyeccion_pct >= 70 ? '#ed6c02' : '#d32f2f';

  return (
    <>
      <div className="dashboard_row">
        <div className="boxIndicator">
          <div className="boxIndicatorContent">
            <TbTargetArrow size={40} />
            <div className="boxIndicatorContentInner">
              <h2>PRESUPUESTO TOTAL</h2>
              <span className="indicatorValue">${Number(total_budget).toLocaleString()}</span>
            </div>
          </div>
        </div>
        <div className="boxIndicator">
          <div className="boxIndicatorContent">
            <PiCurrencyDollarLight size={40} />
            <div className="boxIndicatorContentInner">
              <h2>VENTAS REALES</h2>
              <span className="indicatorValue" style={{ color: proyeccionColor }}>${Number(total_actual_sales).toLocaleString()}</span>
            </div>
            <div className="boxIndicatorContentInner">
              <h2>CUMPLIMIENTO</h2>
              <span className="indicatorValue" style={{ color: cumplimientoColor }}>
                {cumplimiento_pct}%
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard_row">
        <div className="boxIndicator">
          <div className="boxIndicatorContent">
            <PiChartLineUpLight size={40} />
            <div className="boxIndicatorContentInner">
              <h2>PROYECCIÓN</h2>
              <span className="indicatorValue">${Number(proyeccion_pesos).toLocaleString()}</span>
            </div>
            <div className="boxIndicatorContentInner">
              <h2>% PROY.</h2>
              <span className="indicatorValue" style={{ color: proyeccionColor }}>
                {proyeccion_pct}%
              </span>
            </div>
          </div>
        </div>
        <div className="boxIndicator">
          <div className="boxIndicatorContent">
            <PiWarningCircleLight size={40} />
            <div className="boxIndicatorContentInner">
              <h2>FALTANTE</h2>
              <span className="indicatorValue" style={{ color: '#d32f2f' }}>
                ${Number(faltante_pesos).toLocaleString()}
              </span>
            </div>
            <div className="boxIndicatorContentInner">
              <h2>% FALTANTE</h2>
              <span className="indicatorValue" style={{ color: '#d32f2f' }}>
                {faltante_pct}%
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
